import { useAtomValue } from 'jotai';
import { areasInfoAtom } from '@/atoms';

export const useAreas = () => {
  const areasInfo = useAtomValue(areasInfoAtom);

  return areasInfo;
};
